module.exports = "/_next/static/images/e37fbdf52bf3e6dcd907cf0212fdb344-roxinho-card-with-phone-xs@3x.png.webp";